import React from 'react';

import { SVGComponentProps } from './svg.types';

const CheckboxSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block align-middle ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
        <rect x="7.5" y="7.5" width="9" height="9" rx="0.5" stroke="#55585E" />
        <g clipPath="url(#clip0)">
          <path
            d="M11.1346 13.3643L10.1424 12.3717C10.0968 12.3262 10.0607 12.2722 10.0361 12.2128C10.0115 12.1533 9.99878 12.0896 9.99878 12.0253C9.99878 11.9609 10.0115 11.8972 10.0361 11.8378C10.0607 11.7783 10.0968 11.7243 10.1424 11.6788C10.2343 11.587 10.3589 11.5355 10.4888 11.5355C10.6187 11.5355 10.7433 11.587 10.8352 11.6788L11.4566 12.2997C11.4692 12.3122 11.4861 12.3191 11.5038 12.3191C11.5215 12.3191 11.5384 12.3122 11.5509 12.2997L13.1624 10.6883C13.2543 10.5965 13.3789 10.5449 13.5088 10.5449C13.6387 10.5449 13.7633 10.5965 13.8552 10.6883C13.9007 10.7337 13.9368 10.7878 13.9615 10.8472C13.9861 10.9066 13.9988 10.9704 13.9988 11.0347C13.9988 11.099 13.9861 11.1628 13.9615 11.2222C13.9368 11.2816 13.9007 11.3356 13.8552 11.3811L11.8724 13.3643C11.7745 13.4621 11.6418 13.517 11.5035 13.517C11.3652 13.517 11.2325 13.4621 11.1346 13.3643Z"
            fill="#BCBEC2"
          />
        </g>
        <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
        <defs>
          <clipPath id="clip0">
            <rect width="4" height="4" fill="white" transform="translate(10 10)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default CheckboxSVG;
